import { CircleXIcon } from 'lucide-react';
import { Button } from '../button';

type ErrorFallBackProps = {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
};

export function ErrorFallBack({
  title,
  description,
  buttonLabel,
  onClick,
}: ErrorFallBackProps) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-neutral-50 p-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
          <CircleXIcon className="text-red-700" />
        </div>
        <h1 className="mb-2 font-semibold ">{title}</h1>
        <p className="mb-6 text-sm text-neutral-500">{description}</p>
        <Button onClick={onClick} className="w-full">
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
}
